import graphql__b54da2cf96a80a7558d0 from "./__generated__/CommentsList_comments.graphql.js";import { Component } from "react";
import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import Comment from "./Comment";

export const COMMENTS_BATCH_SIZE = 10;

class CommentsList extends Component {
  render() {
    return (
      <div className="comments-list">
        {this.props.comments.map(comment => (
          <Comment key={comment.id} comment={comment} commentable={comment} />
        ))}
      </div>
    );
  }
}

export default createFragmentContainer(CommentsList, {
  comments: graphql__b54da2cf96a80a7558d0
});
